/**
 * Глубина дневной истории — год. Одна константа на сервер и браузер: сервер
 * (lib/daily-coverage.ts, уборка, догрузки) хранит и добирает столько дней,
 * календарь периода в таблице не даёт выбрать раньше. Без базы и Node-модулей,
 * чтобы её мог импортировать клиентский код.
 */
export const DAILY_HISTORY_DAYS = 365;
